import { faqs, siteInfo } from "@/mocks/content";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import HeroSection from "./components/HeroSection";
import CategoryStrip from "./components/CategoryStrip";
import TrendingTicker from "./components/TrendingTicker";
import HotRanking from "./components/HotRanking";
import FeaturedPicks from "./components/FeaturedPicks";
import LatestFeed from "./components/LatestFeed";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";

export default function Home() {
  useDocumentMeta({
    title: "看料91 - 热门爆料与现场记录聚合阅读平台",
    description:
      "看料91聚合热门爆料与现场记录，点开即可进入浏览，支持翻看、阅读、查看完整内容。想看什么直接点，不用绕路，页面内持续更新，方便你快速找到感兴趣的料。",
    keywords: "看料91,看料91点开,看料91浏览,看料91翻看,看料91阅读,热门爆料,现场记录",
    path: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteInfo.name,
          url: "https://fxwlkj.cn/",
          description: siteInfo.intro,
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://fxwlkj.cn/?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: siteInfo.name,
          url: "https://fxwlkj.cn/",
          email: siteInfo.email,
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        },
      ],
    },
  });

  return (
    <>
      <HeroSection />
      <CategoryStrip />
      <TrendingTicker />
      <HotRanking />
      <FeaturedPicks />
      <LatestFeed />
      <FaqSection />
      <BrandSection />
    </>
  );
}